<template>
  <modal
    v-bind="$attrs"
    v-on="$listeners"
    :show-close="false"
  >

  <template v-slot:body>
    <h4>
      {{$t('organizations.users_section.modals.export_report.message')}}
    </h4>
  </template>
  <template v-slot:footer>
    <primary-button @click.native="$emit('closed')">
      {{$t('common.ok')}}
    </primary-button>
  </template>

  </modal>
</template>

<script>
  import Modal from '@/components/common/Modal'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'

  export default {
    props: {
      numberOfSelectedUsers: {
        type: Number,
        default: 0,
      },
    },
    components: {
      Modal,
      PrimaryButton,
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../scss/_colors.scss';

  h4 {
    text-align: left;
    font-weight: 500;
    font-size: 20px;
    color: $black;
    text-align: center;
    line-height: 32px;
    padding: 0 !important;
  }

  ::v-deep .elsa-modal {
    width: 575px !important;
  }
  
  ::v-deep .el-dialog {    
    border-radius: 8px;
    padding-bottom: 24px;

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      border-radius: 8px;  
      padding-bottom: 12px;    
    }

    .el-dialog__footer {
      justify-content: center !important;
    }
  }
  .el-dialog__wrapper {
    display: flex;
    align-items: center;
  }

</style>
